<template>
	<button type="button" @click="onClickSearch"><IconListAlt />&nbsp;</button>
</template>

<script>
	import IconListAlt from "@/components/icons/IconListAlt"

	export default {
		components: {
			IconListAlt
		},
		methods: {
			onClickSearch() {
				this.$modal.show("song-playlists");
			},
			keydownEvent(e) {
				if (e.srcElement.tagName === "INPUT" || e.srcElement.tagName === "TEXTAREA") return;
				if (e.code === "KeyF") {
					this.onClickSearch();
				}
			},
		},
		mounted() {
			//document.addEventListener("keyup", this.keydownEvent);
		},
		destroyed() {
			//document.removeEventListener("keyup", this.keydownEvent);
		}

	}

</script>

<style lang="scss" scoped>
	button {
		width: 48px;

		.icon {
			width: 24px;
			margin: 6px 0 0 -8px;
			position: absolute;
		}
	}
</style>
